// extracted by mini-css-extract-plugin
module.exports = {"content":"expired_content__2kfuZ"};